import { ClientConstants } from '@/constants/ClientConstants';

export default function getEnv(): {
  /**
   * Check if we are running in prerender.io crawler
   * See https://docs.prerender.io/docs/33-overview-of-prerender-crawlers
   */
  isPrerender: boolean;
  isHSBCEnvironment: boolean;
  isCoreEnvironment: boolean;
  isBofAEnvironment: boolean;
  isBarclaysEnvironment: boolean;
  isRBCEnvironment: boolean;
  isSocGenEnvironment: boolean;

  isLocal: boolean;

  /**
   * This variable is true when you are pointing at the production database, regardless of whether or not the code
   * running is the production environment or not. In other words, this can be true when you are pointing your local
   * environment at the production database.
   *
   * When comparing team IDs, always use the checks `isProdStage` and `isUatStage` instead of `isProduction`.
   */
  isProdStage: boolean;

  /**
   * `isProduction` is true only on prod and running as a production build, i.e., when deployed to AWS.
   */
  isProduction: boolean;

  isUatStage: boolean;
  isSitStage: boolean;
} {
  const isLocal = window.location.href.includes('localhost');
  const isHSBCEnvironment = import.meta.env.VITE_CLIENT === ClientConstants.HSBC;
  const isCoreEnvironment = import.meta.env.VITE_CLIENT === ClientConstants.PREMIALAB;
  const isBofAEnvironment = import.meta.env.VITE_CLIENT === ClientConstants.BOFA;
  const isBarclaysEnvironment = import.meta.env.VITE_CLIENT === ClientConstants.BARCLAYS;
  const isRBCEnvironment = import.meta.env.VITE_CLIENT === ClientConstants.RBC;
  const isSocGenEnvironment = import.meta.env.VITE_CLIENT === ClientConstants.SOCGEN;

  const isProdStage = import.meta.env.VITE_STAGE === 'prod';
  const isProduction = import.meta.env.PROD && import.meta.env.VITE_STAGE === 'prod';

  const isUatStage = import.meta.env.VITE_STAGE === 'uat';
  const isSitStage = import.meta.env.VITE_STAGE === 'sit';

  const isPrerender = window.navigator.userAgent.includes('Prerender (+https://github.com/prerender/prerender)');

  return {
    isProduction,
    isLocal,
    isPrerender,
    isHSBCEnvironment,
    isCoreEnvironment,
    isBofAEnvironment,
    isBarclaysEnvironment,
    isRBCEnvironment,
    isSocGenEnvironment,
    isProdStage,
    isUatStage,
    isSitStage,
  };
}

/**
 * In general, you should NOT BE USING THIS FUNCTION.
 * We are using this to selectively show portfolio tree ids on local (but not Cypress)
 * so that we may more conveniently troubleshoot portfolio tree id problems.
 * Everything else should remain the same in the test environment, otherwise it rather defeats
 * the purpose of testing in general...
 */
export function getIsCypress(): typeof window.Cypress {
  return window.Cypress;
}
